/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_appsync_graphqlEndpoint": "https://gaa4of6prbdavpuoatwc6wg4em.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-jvar6cytxbgfnojt6y22pqi2me",
    "aws_cognito_identity_pool_id": "eu-central-1:ebc77ed5-a9ab-4cee-9535-b7ad90cbb39d",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_zhEHe7Qir",
    "aws_user_pools_web_client_id": "lg8nsff4vab1ocu9ek3svtaat",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "gokus375854-prod",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
